import { LastRingSchema } from "@/schemas/user.schema"
import { syncStore$ } from "@/stores/sync.v2.store"
import type { IRegisterDocumentProps } from "@/sync/syncTypes"
import consola from "consola"

export const LastRingDocumentHandler = (name: string): IRegisterDocumentProps => ({
  name,
  onFailure: (error: unknown) => {
    consola.error(`Document ${name} failed`, error)
  },
  onRemoved: () => {
    consola.debug(`Document removed: ${name}`)
  },
  onDocumentUpdated: (data: unknown, rawData: unknown) => {
    const parsedItem = LastRingSchema.safeParse(data)
    if (!parsedItem.success) {
      consola.warn(`We will ignore the update from ${name} because the data is invalid`, parsedItem.error)
      return
    }

    syncStore$.lastRing.set(parsedItem.data)

    consola.debug(`Updated state from ${name}`)
  },
})
